import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

import '../style/topbar.css';
import kaliaLogo from '../assets/images/kalia-logo.png';

function Topbar(){
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);

    const handleNavClick = () => {
        setExpanded(false);
    };

    return(
        <Navbar className="nav-bar" sticky="top" expand="lg" expanded={expanded} onToggle={setExpanded}>
            <Container>
                <Navbar.Brand as={Link} to='/' onClick={handleNavClick}>
                    <img src={kaliaLogo} alt="Kalia" className="brand-logo" />
                </Navbar.Brand>
                <div className="language-switcher-mobile">
                    <LanguageSwitcher />
                </div>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Nav.Link as={NavLink} to='/' onClick={handleNavClick}>{t('header.home')}</Nav.Link>
                    <NavDropdown title={t('header.services')}>
                        {/* <NavDropdown.Item as={Link} to='/services/ai-ml' style={{textAlign:'left'}}>{t('carousel.dataScience.title')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/data-analytics' style={{textAlign:'left'}}>{t('carousel.dataAnalytics.title')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/data-acquisition' style={{width:'15vw', textAlign:'left'}}>{t('carousel.dataAcquisition.title')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/task-automation' style={{textAlign:'left'}}>{t('carousel.taskAutomation.title')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/system-architecture' style={{width:'15vw', textAlign:'left'}}>{t('carousel.systemArchitecture.title')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/development' style={{width:'15vw', textAlign:'left'}}>{t('carousel.development.title')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/website-creation' style={{width:'15vw', textAlign:'left'}}>{t('carousel.websiteCreation.title')}</NavDropdown.Item> */}
                        <NavDropdown.Item as={Link} to='/services/data-ai' style={{width:'15vw', textAlign:'left'}} onClick={handleNavClick}>{t('header.topbar.dataAI')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/automation' style={{width:'15vw', textAlign:'left'}} onClick={handleNavClick}>{t('header.topbar.automation')}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to='/services/dev' style={{width:'15vw', textAlign:'left'}} onClick={handleNavClick}>{t('header.topbar.development')}</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link as={NavLink} to='/consulting' onClick={handleNavClick}>{t('header.consulting')}</Nav.Link>
                    <Nav.Link as={NavLink} to='/blog' onClick={handleNavClick}>{t('header.blog')}</Nav.Link>
                    <Nav.Link as={NavLink} to='/contact' onClick={handleNavClick}>{t('header.contact')}</Nav.Link>
                    <Nav.Link as={NavLink} to='/about' onClick={handleNavClick}>{t('header.about')}</Nav.Link>
                </Nav>
                <div className="language-switcher-desktop">
                    <LanguageSwitcher />
                </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Topbar;